<template>
  <v-main>
    <Header />
    <v-container fluid>
      <router-view :key="$route.path" />
    </v-container>
    <Footer />
  </v-main>
</template>
<script>
import Header from "@/components/app/Header";
import Footer from "@/components/app/Footer";
export default {
  components: { Footer, Header },
};
</script>
